import { proxy } from "valtio";

/**
 * Auth store for tracking authentication state
 * Note: Primary auth state comes from InstantDB's db.useAuth() hook
 * This store is for additional app-level auth state
 */
interface AuthStore {
  /** Whether a magic link has been sent */
  magicLinkSent: boolean;
  /** Email that magic link was sent to */
  sentToEmail: string | null;
  /** Login error message */
  loginError: string | null;
}

export const authStore = proxy<AuthStore>({
  magicLinkSent: false,
  sentToEmail: null,
  loginError: null,
});

/** Reset auth store to initial state */
export function resetAuthStore() {
  authStore.magicLinkSent = false;
  authStore.sentToEmail = null;
  authStore.loginError = null;
}

/** Set magic link sent state */
export function setMagicLinkSent(email: string) {
  authStore.magicLinkSent = true;
  authStore.sentToEmail = email;
  authStore.loginError = null;
}

/** Set login error */
export function setLoginError(error: string) {
  authStore.loginError = error;
}
